import React from "react";
import { connect } from "react-redux";

import {
  Form,
  FormElement,
  FormValidator,
  CustomTextControl,
  BaseReactComponent,
  SelectControl,

} from "../../utils/form";
import { Row, Col, Button } from "react-bootstrap";
import { filterVerifiedItems } from "../../utils/ReusableFunctions";
import "react-datepicker/dist/react-datepicker.css";
import { getAllCalenderApi, getAllCalenderFilterApi } from "./Api";
import { CalendarContent, ClearButton, ImageUploader, TemplatesContent } from "../common";
import { postAuthCommonApi, putAuthCommonApi } from "../content/Api";
import ReactDOM from "react-dom";
import { isModuleExist, MAX_LIMIT, MODULE_ID_MAP } from "../../utils/Constant";
import { toast } from "react-toastify";
import { getDetailsCalendarApi } from "../MasterCategory/Api";
import { withRouter } from "../../utils/hoc/withRouter";
import { getAllSsoPartnersApi } from "../sso/Api";
import { isPartnerAllowed } from "../../utils/ReusableFunctions";

class AddEditCalender extends BaseReactComponent {
  constructor(props) {
    super(props);
    const data = props?.location.state?.data || null;
    const AccesData = isModuleExist(MODULE_ID_MAP.SubDomainCalendar);
    let partners = this.loadDefaultPartners(AccesData)
    if (data?.partners?.list) {
      partners = data?.partners
    }
    this.state = {
      editData: data,
      
      templateUuid: data?.uuid || "",
      isUpdated: (props?.location.state ?? false) || false,
      calenderImage: data?.calenderImage || null,
      baseImage: data?.baseImage || null,
      placeholderImage: data?.placeholderImage || null,
      frameImage: data?.frameImage || null,
      sampleImage: data?.sampleImage || null,
      calenderName: data?.calenderName || "",
      AccessData: AccesData,
      resLoading: false,
      description: data?.description || "",
      filterOptions: [],
      pageSize: MAX_LIMIT,
      isCanvasOpen: false,
      filtersUuid: [],
      variations: [],
      partners,
    };

  };


  async componentDidMount() {
    getAllSsoPartnersApi(this);

    this.props.getAllCalenderFilterApi(this);


    if (this.props?.location?.state?.data?.uuid) {
      this.setState({ loading: true })
      await getDetailsCalendarApi("/calender", this).finally(() => {
        this.setState({ loading: false })
      });
    };

  };
  componentDidUpdate(prevProps, prevState) {
    if (this.props.calenderFilterData !== prevProps.calenderFilterData) {
      const filterOptions = filterVerifiedItems(this.props.calenderFilterData?.list).map(filter => ({
        value: filter?.uuid,
        label: filter?.filterName
      }));
      this.setState({ filterOptions });
    }
  };

  imageUploaser = (e, name) => {

    this.setState({ [name]: e.target.files[0] })

  }


  handlePageSize = (pageSize) => {
    // console.log("Heyyy pageSize", pageSize);
  };
  handleSave = () => {
    ReactDOM.findDOMNode(this.form).dispatchEvent(
      new Event("submit", { cancelable: true, bubbles: true })
    );
  };

  onValidSubmit = async () => {

    this.setState({ resLoading: true });
    const { calenderName,
      description,
      baseImage,
      calenderImage,
      placeholderImage,
      frameImage,
      sampleImage,


    } = this.state;

    if (!calenderName || !description || !baseImage || !calenderImage || !placeholderImage || !frameImage || !sampleImage) {
      toast.error("Please fill all required fields");
      this.setState({ resLoading: false });
      return;
    }

    // const calenderData = {
    //   "data": {
    //     "calenderName": calenderName,
    //     "description": description,
    //     "filtersUuid": filters
    //   }
    // };

    const calenderData = {
      "data": {
        "calenderName": calenderName,
        "description": description,
        "filtersUuid": this.state.filtersUuid?.join(",") || "",
        'partners': this.state.partners,
      }
    }
    if (!isPartnerAllowed(this.state.AccessData?.id)) {
      delete data.data.partners;
    }
    if(baseImage?.name){
      calenderData.data.baseImage = baseImage.name;
    }
    if(calenderImage?.name){
      calenderData.data.calenderImage = calenderImage.name;
    }
    if(placeholderImage?.name){
      calenderData.data.placeholderImage = placeholderImage.name;
    }
    if(frameImage?.name){
      calenderData.data.frameImage = frameImage.name;
    }
    if(sampleImage?.name){
      calenderData.data.sampleImage = sampleImage.name;
    }
    const data = new FormData();
    data.append("key", JSON.stringify(calenderData));

    if (baseImage && typeof (baseImage) === 'object') {
      data.append("file", baseImage);
    }
    if (calenderImage && typeof (calenderImage) === 'object') {
      data.append("file", calenderImage);
    }
    if (placeholderImage && typeof (placeholderImage) === 'object') {
      data.append("file", placeholderImage);
    }
    if (frameImage && typeof (frameImage) === 'object') {
      data.append("file", frameImage);
    }
    if (sampleImage && typeof (sampleImage) === 'object') {
      data.append("file", sampleImage);
    }

    if (this.state.templateUuid) {
      const response = await putAuthCommonApi(`calender/${this.state.templateUuid}`, data);
      if (response.status === 200) {
        this.setState({ resLoading: false });
        this.props.history({ pathname: `/calender`, search: 'pageSize=10&pageNumber=1' });
      } else {
        this.setState({ resLoading: false });
      }
    } else {
      const response = await postAuthCommonApi('/calender', data);
      if (response.status === 200) {
        this.setState({ resLoading: false });
        this.props.history({ pathname: `/calender`, search: 'pageSize=10&pageNumber=1' });
      } else {
        this.setState({ resLoading: false });
      }
    }
  };



  openCanvas = async () => {
    this.setState({ isCanvasOpen: true })
  };

  updateCanvasData = (canvasData) => {

    const { variations } = this.state;
    const updatedVariations = variations;
    updatedVariations[0] = {
      ...updatedVariations[0],
      personalizationTemplateVariationImages: canvasData
    };
    this.setState({ variations: updatedVariations, isCanvasOpen: false })
  }
              isFile = (v) => v instanceof File || v instanceof Blob;


  render() {
    const {
      filterOptions,
      isCanvasOpen,
      variations,
      baseImage,
      calenderImage,
      placeholderImage,
      frameImage,
      sampleImage,
      
    } = this.state;
    const {isFile}=this;
    // const {platformData}=this.props.autoShareState
    return (
      <>

        {isCanvasOpen ?
          <div className="canvas-section">

            <CalendarContent
              onClose={() => this.setState({ isCanvasOpen: false })}
              onSave={(updatedCanvasData) => this.updateCanvasData(updatedCanvasData)}
              personalizationTemplateVariationImages={variations?.[0]?.personalizationTemplateVariationImages}
            />

          </div>
          :
          <section className="add-section">
            <ComponentHeader
              title={this.state.templateUuid ? "Update Calendar" : "Add Calendar"}
              primaryBtn="Save"
              isBackArrow={true}
              resLoading={this.state.resLoading}
              isReturn="/calender?pageSize=10&pageNumber=1"
              handlePrimaryBtn={this.handleSave}
            />

            <Form ref={(el) => (this.form = el)} onValidSubmit={this.onValidSubmit}>
              <Row>
                {isPartnerAllowed(this.state.AccessData?.id) &&
                  <Col md={4}>
                    <FormElement
                      valueLink={this.linkState(this, "partners.list")}
                      label="Publish To Partner(s)"
                      required
                      validations={[
                        {
                          validate: FormValidator.isRequired,
                          message: "Publish To cannot be empty",
                        },
                      ]}
                      control={{
                        type: SelectControl,
                        settings: {
                          options: this.state?.ssoPartnersOptions || [],
                          placeholder: "Select Partner(s)",
                          multiple: true,
                          searchable: true,
                          selectAll: true,
                          onChangeCallback: (onBlur) => {
                          },
                        },
                      }}
                    />

                  </Col>}
                <Col md={4}>
                  <FormElement
                    valueLink={this.linkState(this, "calenderName")}
                    label="Calendar Name"
                    required
                    validations={[
                      {
                        validate: FormValidator.isRequired,
                        message: "Name cannot be empty",
                      },
                    ]}
                    control={{
                      type: CustomTextControl,
                      settings: {
                        placeholder: "Enter Name",
                      },
                    }}
                  />
                </Col>
                <Col md={4}>
                  <FormElement
                    valueLink={this.linkState(this, "filtersUuid")}
                    label="Select Filter"
                    required
                    validations={[
                      {
                        validate: FormValidator.isRequired,
                        message: "Filter cannot be empty",
                      },
                    ]}
                    control={{
                      type: SelectControl,
                      settings: {
                        placeholder: "Select Filter",
                        options: filterOptions,
                        multiple: true,
                        searchable: true,
                      },
                    }}
                  />
                  {this.state.filtersUuid?.length > 0 &&
                    <ClearButton onClick={() => this.setState({ filtersUuid: [] })} />
                  }
                </Col>
              </Row>
              <Row>

                <Col md={4}>
                  <FormElement
                    valueLink={this.linkState(this, "description")}
                    label="Description"
                    helpText="Description can't be more than 4000 character"
                    // required
                    // validations={[
                    //   {
                    //     validate: FormValidator.isRequired,
                    //     message: "Field cannot be empty",
                    //   },
                    // ]}
                    control={{
                      type: CustomTextControl,
                      settings: {
                        placeholder: "Please enter description",
                        as: "textarea",
                        rows: 5,
                      },
                    }}
                    classes={{
                      inputField: "custom-input",
                      label: "custom-label",
                    }}
                  />
                </Col>


                <Col sm={4}>
                  <ImageUploader
                    required
                    id="BaseImage"
                    label="Upload Base Image"
                    name={isFile(baseImage) ? URL.createObjectURL(baseImage) : baseImage}
                    onChange={(e) => this.imageUploaser(e, "baseImage")}
                    onDelete={() => this.setState({ baseImage: "" })}
                    acceptedFileType="image/*"
                  />
                </Col>

                <Col sm={4}>
                  <ImageUploader
                    required
                    id="CalendarImage"
                    label="Upload Calendar Image"
                    name={isFile(calenderImage) ? URL.createObjectURL(calenderImage) : calenderImage}
                    onChange={(e) => this.imageUploaser(e, "calenderImage")}
                    onDelete={() => this.setState({ calenderImage: "" })}
                    acceptedFileType="image/*"
                  />
                </Col>

                <Col sm={4}>
                  <ImageUploader
                    required
                    id="PlaceholderImage"
                    label="Upload Placeholder Image"
                    name={isFile(placeholderImage) ? URL.createObjectURL(placeholderImage) : placeholderImage}
                    onChange={(e) => this.imageUploaser(e, "placeholderImage")}
                    onDelete={() => this.setState({ placeholderImage: "" })}
                    acceptedFileType="image/*"
                  />
                </Col>

                <Col sm={4}>
                  <ImageUploader
                    required
                    id="FrameImage"
                    label="Upload Frame Image"
                    name={isFile(frameImage) ? URL.createObjectURL(frameImage) : frameImage}
                    onChange={(e) => this.imageUploaser(e, "frameImage")}
                    onDelete={() => this.setState({ frameImage: "" })}
                    acceptedFileType="image/*"
                  />
                </Col>

                <Col sm={4}>
                  <ImageUploader
                    required
                    id="SampleImage"
                    label="Upload Sample Image"
                    name={isFile(sampleImage) ? URL.createObjectURL(sampleImage) : sampleImage}
                    onChange={(e) => this.imageUploaser(e, "sampleImage")}
                    onDelete={() => this.setState({ sampleImage: "" })}
                    acceptedFileType="image/*"
                  />
                </Col>

              </Row>


            </Form>
          </section>
        }
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  calenderFilterData: state.SubdomainState.calenderFilterList,
});
const mapDispatchToProps = {


  getAllCalenderApi,
  getAllCalenderFilterApi

};
AddEditCalender.propTypes = {


};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AddEditCalender));